// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ActionBar component
 */

import React from 'react';
import IconMenu from 'share/components/controls/Izenda.IconMenu';
import AuthorizationValidator from 'share/components/hoc/Izenda.AuthorizationValidator';
import Button from 'share/components/controls/Izenda.Button';
import Alert from 'share/components/controls/Izenda.Alert';
import action from './Izenda.ActionBarAction';
import connect from 'share/enhancers/Izenda.Connect';

const ActionBar = connect(action)((props: any) => {
  const AuthorizationButton = AuthorizationValidator()(Button);
  const {
    store: { alertMessage, configUserCloned },
    localization,
    authorization,
    authorizationConstants,
    readOnly,
    onClickPasswordOptions,
    onSave,
    onCancel
  } = props;
  const isAllowConfigPasswordOption =
    !readOnly &&
    authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.UserSetupActionsConfigureSecurityOptions]);
  const enableBtn = authorization.checkPrivileges(
    [
      authorizationConstants.PERMISSION_KEY.UserSetupActionsCreate,
      authorizationConstants.PERMISSION_KEY.UserSetupActionsEdit
    ],
    authorizationConstants.PERMISSION_OPERATOR.Or
  );
  return (
    <div className="izenda-Wrapper-header">
      <IconMenu />

      <Alert className="u_floatLeft" type={alertMessage.type}>
        {alertMessage.message}
      </Alert>

      <div className="izenda-ActionBarRight">
        <AuthorizationButton
          label={localization.getText('USER_SETUP_LABEL_PASSWORD_OPTIONS')}
          onClick={onClickPasswordOptions}
          disabled={configUserCloned.isNew || configUserCloned.formHasErrors || !isAllowConfigPasswordOption}
          keys={[authorizationConstants.PERMISSION_KEY.UserSetupActionsConfigureSecurityOptions]}
          integrationHidden={true}
          className='btn-report-default'
        />
        <Button
          label={localization.getText('COMMON_LABEL_SAVE')}
          className="u_marginLeft"
          onClick={onSave}
          disabled={!enableBtn}
        />
        <Button
          label={localization.getText('COMMON_LABEL_CANCEL')}
          className="u_marginLeft btn-report-default"
          onClick={onCancel}
          disabled={!enableBtn}
        />
      </div>
    </div>
  );
});

export default ActionBar;



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/ActionBar/Izenda.ActionBar.jsx